// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4576":"0e238aefdabade8b","8780":"0e238aefdabade8b"}[chunkId] + ".css";
};